import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Loader } from '@jutro/components';
import { MetadataContent } from '@jutro/uiconfig';
//import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext, withIntl } from '@jutro/locale';
import { GatewayPolicyService } from 'gw-capability-ri-policy';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { gatewayMessages } from 'gw-capability-ri-policy-react';
import ExcelJS from "exceljs";
import saveAs from "file-saver";
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import claimMessages from '../../Claims.messages';
import metadata from './PolicyClaims.metadata.json5';
import styles from './PolicyClaims.module.scss';

const { fnolLobs, fnolLobsConfig } = appConfig;
const getFnolLobs = _.reduce(
    fnolLobs,
    (namesLiterals, policyType) => namesLiterals.concat(fnolLobsConfig[policyType]),
    []
);

class PolicyClaims extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                    account: PropTypes.shape({
                        policySummaries: PropTypes.array
                    }),
                    product: PropTypes.shape({
                        productCode: PropTypes.string
                    }),
                    latestPeriod: PropTypes.shape({
                        canceled: PropTypes.string
                    })
                })
            })
        }).isRequired,
        intl: PropTypes.func.isRequired
    };

    static contextType = TranslatorContext;

    state = {
        claimResponse: '',
        claimDataTable: '',
        searchFilter: '',
        isLoading: true
    };

    getSearchFilterValues = (claimsArrayResult, filter) => {
        const lowerCaseFilterValue = filter.value.toLocaleLowerCase();
        return _.filter(claimsArrayResult, (res) => {
            return Object.keys(res).some(
                (key) => typeof res[key] === 'string'
                    && res[key].toLocaleLowerCase().includes(lowerCaseFilterValue)
            );
        });
    };

    getClaimDataTable = (claimsData, filter) => {
        const { intl } = this.props;
        let claimsArrayResult = claimsData;
        if (filter.type === 'SearchFilter') {
            claimsArrayResult = this.getSearchFilterValues(claimsArrayResult, filter);
        }
        claimsArrayResult = claimsArrayResult.map((claimInfo) => {
            const claims = {
                claimNumber: claimInfo.claimNumber,
                dateOfLoss: intl.formatDate(new Date(claimInfo.lossDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                status: claimInfo.status,
                paid: claimInfo.totalPayments,
                netIncurred: claimInfo.totalIncurredNet,
                reportedDate: intl.formatDate(new Date(claimInfo.reportedDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                policyNumber: claimInfo.policyNumber,
                claimantName: claimInfo.claimantName,
                injuryDesc: claimInfo.injuryDesc,
                injuryBodyPart: claimInfo.injuryBodyPart,
                accidentDesc: claimInfo.accidentDesc,
                status: claimInfo.status,
                jobDesc: claimInfo.jobDesc,
                accidentLocation: claimInfo.accidentLocation,
                amountPaid: claimInfo.amountPaid,
                totalIncurred: claimInfo.totalIncurred
            };
            return claims;
        });
        this.setState({
            claimDataTable: claimsArrayResult
        });
    };

    componentDidMount = () => {
        const { authHeader, fromAccountLanding } = this.props;
        const { policyNumber } = fromAccountLanding.policyDetailsData.policyResponse;
        GatewayPolicyService.getPolicyClaims(policyNumber, authHeader).then((response) => {
            const filter = {
                type: null,
                value: null
            };
            this.getClaimDataTable(response, filter);
            this.setState({
                claimResponse: response,
                isLoading: false
            });
        });
    };

    handleFilterChange = (value) => {
        const { claimResponse } = this.state;
        const filter = {
            type: 'SearchFilter',
            value: value
        };
        this.setState(
            {
                searchFilter: value
            },
            () => {
                this.getClaimDataTable(claimResponse, filter);
            }
        );
    };

    handleFileClick = () => {
        
        const {
            history,
            fromAccountLanding: {
                policyDetailsData: { policyResponse }
            }
        } = this.props;
        const { policyNumber } = policyResponse;
        const redirectClaimsPath = `/ri-policies/${policyNumber}/claims`; 
        
        return history.push({
            pathname: '/fnol-select-policy',
            state: {
                policyNumber: policyNumber,
                redirectPath: redirectClaimsPath
            }
        });
    };

    handleExportClick = (e) => {
        this.buildExcelData();
    };

    buildExcelData = () => {
        var { claimDataTable } = this.state;
        
        var dataForExcel = [];
        var header = [];
        claimDataTable.forEach((claimInfo) => {
            const rowToExport = {
                'Date of Injury' : moment(claimInfo.dateOfLoss).format('MM/DD/YYYY'),
                'Claim #': claimInfo.claimNumber,
                'Policy #': claimInfo.policyNumber,
                'Claimant': claimInfo.claimantName,
                'Injury Description': claimInfo.injuryDesc,
                'Body Part': claimInfo.injuryBodyPart,
                'Accident Description': claimInfo.accidentDesc,
                'Claim Status': claimInfo.status,
                'Job Description': claimInfo.jobDesc,
                'Injury Location': claimInfo.accidentLocation,
                'Total Incurred': claimInfo.totalIncurred.amount,
                'Total Paid': claimInfo.amountPaid.amount
            };
            header = Object.keys(rowToExport);
            dataForExcel.push(Object.values(rowToExport));
        });

        let reportData = {
            data: dataForExcel,
            headers: header
          }        
        this.exportExcel(reportData);
      };

    exportExcel = (reportData) => {
        const header = reportData.headers
        const data = reportData.data;

        var workbook = new ExcelJS.Workbook();
        var worksheet = workbook.addWorksheet("Claims");

        let headerRow = worksheet.addRow(header);
        worksheet.getRow(1).font = { bold: true };
        data.forEach(d => {
            let row = worksheet.addRow(d);
        });
        //workbook.xlsx.writeFile('sales-report.xlsx');    
        workbook.xlsx.writeBuffer().then(function(buffer) {
            saveAs(
                new Blob([buffer], { type: "application/octet-stream" }),
                `claims-summary.xlsx`
              );
            });        
    };

    getCell = (item, index, property) => {
        const translator = this.context;
        const toolTipMessage = {
            dateOfLoss: translator(claimMessages.dateOfLoss),
            status: translator(claimMessages.status)
        };
        return  <div 
                    title={toolTipMessage[property.id]}                     
                    className={property.id === 'dateOfLoss' || property.id === 'claimantName' ? styles.riNoWrapCell : ''} 
                >
                    {item[property.id]}
                </div>;
    };

    getCurrencyCell = (item, index, property) => {
        const translator = this.context;
        const toolTipMessage = {
            paid: translator(claimMessages.paid),
            netIncurred: translator(claimMessages.netIncurred)
        };
        return (
            <span title={toolTipMessage[property.id]}>
                <CurrencyField
                    id={`currency_${index}`}
                    value={item[property.id]}
                    datatype="object"
                    title={toolTipMessage}
                    readOnly
                    hideLabel
                />
            </span>
        );
    };

    getLink = (item, index, property) => {
        const translator = this.context;
        const { fromAccountLanding } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );

        const toolTipMessage = {
            policyNumber: translator(claimMessages.policyNumber),
            claimNumber: translator(claimMessages.claimNumber)
        };

        if (
            item.status
            === translator({
                id: 'typekey.ClaimState.draft',
                defaultMessage: 'Draft'
            })
        ) {
            const redirectpath = {
                pathname: '/fnol-select-policy',
                state: {
                    claimNumber: item[property.id],
                    redirectPath: `/ri-policies/${policyNumber}/claims`,
                    claimStatus: item.status
                }
            };
            return (
                <Link to={redirectpath}
                    className={styles.gwClaimsLinkContent} 
                    title={toolTipMessage[property.id]}
                >
                    {item[property.id]}
                </Link>
            );
        }

        const redirectRoute = property.id === 'policyNumber'
            ? `/ri-policies/${item[property.id]}/summary`
            : `/ri-claims-details/${item[property.id]}`;

        const redirectPath = {
            pathname: redirectRoute,
            state: {
                claimNumber: item[property.id],
                redirectPath: `/ri-policies/${policyNumber}/claims`,
                claimStatus: item.status
            }
        };

        return (
            <Link to={redirectPath}
                  className={styles.gwClaimsLinkContent} 
                  title={toolTipMessage[property.id]}>
                {item[property.id]}
            </Link>

        );
    };

    checkIfPolicyIsInForceStatus = (latestPeriod) => {
        const translator = this.context;
        return (
            latestPeriod.status
                === translator({ id: 'typekey.PolicyPeriodStatus.Bound', defaultMessage: 'Bound' })
            && !moment().isBefore(moment(latestPeriod.effectiveDate))
        );
    };

    getFileClaimButtonVisible = () => {
        const {
            fromAccountLanding: {
                policyDetailsData: { policyResponse }
            }
        } = this.props;
        const policyType = _.get(policyResponse, 'product.productCode', '');
        const policyNumber = _.get(policyResponse, 'policyNumber', '');
        return (
            getFnolLobs.includes(policyType)
            && policyNumber
            && !policyResponse.latestPeriod.canceled
            && this.checkIfPolicyIsInForceStatus(policyResponse.latestPeriod)
        );
    };

    sortDate = (a, b) => {        
        const date1 = new Date(a);
        const date2 = new Date(b);
        
        if (date1 > date2) return 1;
        if (date1 < date2) return -1;
        return 0;
    };

    sortJSON = (arr, key, type, way) => {
        return arr.sort(function(a, b) {
            
            var x = a[key]; var y = b[key];
            if(type === 'date'){
                x = new Date(a[key]);
                y = new Date(b[key]);
            } else if(type === 'number'){
                x = x + 0;
                y = y + 0;
            }
            if (way === 'A') { return ((x < y) ? -1 : ((x > y) ? 1 : 0)); }
            if (way === 'D') { return ((x > y) ? -1 : ((x < y) ? 1 : 0)); }
        });
    };    

    render() {
        const {
            claimDataTable, claimResponse, searchFilter, isLoading
        } = this.state;
        
        const translator = this.context;

        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        const overrides = {
            claimDataTable: {
                data: this.sortJSON(claimDataTable, 'dateOfLoss', 'date', 'D')
            },
            fileClaimButton: {
                visible: this.getFileClaimButtonVisible()
            },
            exportClaimsButton: {
                visible: !_.isEmpty(claimResponse)
            },
            searchFilter: {
                value: searchFilter,
                visible: !_.isEmpty(claimResponse)
            },
            noDataMessageContainer: {
                visible: _.isEmpty(claimResponse)
            },
            noDataMessage: {
                value: translator(gatewayMessages.noClaimsResult)
            },
            paidColumnTitle: {
                visible: appConfig.persona === 'producer' || appConfig.persona === 'csr' || appConfig.persona === 'policyholder'
            },
            netIncurredColumnTitle: {
                visible: appConfig.persona === 'producer' || appConfig.persona === 'csr' || appConfig.persona === 'policyholder'
            }
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getCurrencyCell: this.getCurrencyCell,
                getAccount: this.getAccount,
                getLink: this.getLink,
                handleSearchValueChange: this.handleFilterChange,
                handleFileClick: this.handleFileClick,
                sortDate: this.sortDate,
                handleExportClick: this.handleExportClick
            }
        };
        //const claimPage = renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
        const claimPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
        return (
            <div>
                {claimPage}
            </div>
        );
    }
}

export const PolicyClaimsComponent = PolicyClaims;
export default withIntl(withAuthenticationContext(PolicyClaims));
